(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('bozoraka-admin-');
        $sessionStorageProvider.setKeyPrefix('bozoraka-admin-');
    }
})();
